// extracted by mini-css-extract-plugin
module.exports = {"tab__container":"TabLayout_tab__container__yWprK","tabs":"TabLayout_tabs__zYVFO","placeholder":"TabLayout_placeholder__wHgW1"};